<template>
  <div class="container test-results">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Hearing loss classification results</h1>
        </div>
        <div class="title-divider"></div>
        <a @click.prevent="$router.back()" class="back-button" href="#"
        >
          <svg
            class="bi bi-arrow-left"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg
          >
          Back</a
        >
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="position-wrapper">
          <div @click="showOnly('L')" class="left-wrapper">
            <div :style="{backgroundColor: visible.L ? '#0e9fcc' : '#fff'}" class="left-line"></div>
            <p>Left</p>
          </div>
          <div @click="showOnly('R')" class="right-wrapper">
            <div :style="{backgroundColor: visible.R ? '#fe4a49' : '#fff'}" class="right-line"></div>
            <p>Right</p>
          </div>
        </div>
      </div>
    </div>

    <Chart v-model="visible" :show-classifications="true"/>

    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            This graph shows the different classifications of hearing loss using
            different colors. The lower down the chart points are plotted, the
            worse the hearing. People who have mild hearing loss have some
            difficulties keeping up with conversations, especially in noisy
            surroundings.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="button-wrapper">
          <router-link to="/select-gender" class="button-main">re-test</router-link>
          <router-link
            :to="$store.getters.isLoaded ? '/successful' : '/save-to-database'"
            class="button-main"
          >
            next step
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import hearingLoss from "./hearing-loss-results";

  export default {
    extends: hearingLoss,
  }
</script>
